<template>
  <label class="toggle-switch">
    <input
      :id="inputData.name"
      :name="inputData.name"
      :required="inputData.required"
      type="checkbox"
      class="input-boolean"
      v-model="inputVal"
      @change="onChange"
      @focus="onFocus"
      @blur="onBlur"
    />
    <span class="toggle-slider">
      <span class="toggle-title">{{title}}</span>
    </span>
  </label>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'

export default {
  name: 'SliderCheckbox',
  components: {},
  props: {
    value: Boolean,
    data: Object
  },
  data: function() {
    return {
      inputData: {
        value: '',
        type: false,
        name: '',
        required: false
      },
//      value: false
    }
  },
  computed: {
    inputVal: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    },
    title: function () {
      if (this.inputVal)
        return 'Yes'
      return 'No'
    }
  },
  methods: {
    alert: function(msg) {
      this.$store.commit('openToast', {
        text: msg,
        type: 'warning'
      })
    },
    validate: function(alert) {
      alert = alert === true ? true : false
      this.$emit('input:value', this.inputVal)
      this.inputData.value = this.inputVal
      const parsedValue = PreApproveMe.parseInputValue(this.inputData)
      this.$emit('input:value-parsed', parsedValue)
      if (true) {
        this.$emit('input:isvalid', true)
      } else {
        this.$emit('input:isvalid', false)
        if (alert) {
          this.alert('You must agree to continue')
        }
      }
    },
    formValidate: function() {
      if (this.$store.getters.getSection(this.sectionid) !== null && this.$store.getters.getPage(this.pageid) !== null)
        this.validate(false) // Change to true to alert
    },
    onChange: function() {
      // Temporary hack
      //this.value = !this.value
    },
    onFocus: function() {
      this.isFocused = true
      this.$emit('input:isfocused', true)
    },
    onBlur: function() {
      this.validate()
      this.isFocused = false
      this.$emit('input:isfocused', false)
    },
  },
  created: function() {
    if (this.data.Type) this.inputData.type = this.data.Type
    else this.inputData.type = PreApproveMe.getInputType('Agreements') // ?
    this.inputData.name = this.data.Id
    this.inputData.required = this.data.Required

    if (this.value) {
      this.validate()
    }

    this.$root.$on('form:validate', this.formValidate)
    this.$root.$on('form:validate-force', this.validate)
  }
}
</script>

<style scoped lang="scss">
.toggle-switch {
  float: right;
  position: relative;
  width: 62px;
  height: 24px;
  > .toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 24px;
    &:before {
      position: absolute;
      content: '';
      height: 20px;
      width: 20px;
      left: 2px;
      bottom: 2px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 50%;
    }
    .toggle-title {
      position: absolute;
      font-size: 16px;
      color: white;
      top: 6px;
      left: 28px;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
  }
  > input {
    opacity: 0;
    width: 0;
    height: 0;
    &:checked + .toggle-slider {
      background-color: #2196f3;
      .toggle-title {
        left: 6px;
      }
    }
    &:focus + .toggle-slider {
      box-shadow: 0 0 1px #2196f3;
    }
    &:checked + .toggle-slider:before {
      -webkit-transform: translateX(38px);
      -ms-transform: translateX(38px);
      transform: translateX(38px);
    }
  }
}
</style>
